import AdditionalConfigRequiredOption from '../components/organisms/office_hours/AdditionalConfigRequiredOption'
import AdditionalConfigSuggestedOption from '../components/organisms/office_hours/AdditionalConfigSuggestedOption'
import AdditionalConfigSuggestedRequiredOption from '../components/organisms/office_hours/AdditionalConfigSuggestedRequiredOption'

const DEFAULT_HOURS = {
  start: '7:00',
  end: '15:00',
  receptionDeskMinStartHour: '6:00',
  receptionDeskMaxStartHour: '15:00'
}

const componentOptions = {
  required: AdditionalConfigRequiredOption,
  suggested_required: AdditionalConfigSuggestedRequiredOption,
  suggested: AdditionalConfigSuggestedOption
}

const otherFormAdditionalConfigOptions = ['required', 'suggested_required', 'suggested']

const receptionDeskAdditionalConfigOptions = ['required', 'suggested_required']

const getPageDescription = ({ canFilterByInstitution }) => {
  if (canFilterByInstitution) return 'Selecciona la entidad cuya configuración de horario de atención quieres ver.'
  return 'Configura el horario de atención de tu entidad para que puedas incluirlos en tus formularios.'
}

export {
  DEFAULT_HOURS as defaultHours,
  componentOptions,
  otherFormAdditionalConfigOptions,
  receptionDeskAdditionalConfigOptions,
  getPageDescription
}
